import { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { TopBar } from './TopBar';
import { useIsDesktop } from './useIsDesktop';

export function WorkspaceLayout() {
  const isDesktop = useIsDesktop();
  const { pathname } = useLocation();
  const previousPath = useRef<string | undefined>(undefined);

  // Move focus to the page heading after a path change, not on the first render (A11Y-010).
  useEffect(() => {
    const previous = previousPath.current;
    if (previous !== undefined && previous !== pathname) {
      document.querySelector<HTMLElement>('main h1')?.focus();
    }
    previousPath.current = pathname;
  }, [pathname]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}>
      <TopBar />
      <Box component="main" sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </Box>
      {!isDesktop && <BottomNav />}
    </Box>
  );
}
